import { Injectable } from '@angular/core';
import { TolgeeService } from '@core/translation/tolgee.service';
import { HashMap } from '@core/translation/translation-models';

/**
 * @deprecated Use TolgeeService directly. This service is kept for backwards compatibility.
 */
@Injectable({
    providedIn: 'root'
})
export class TranslationService {

    constructor(private tolgeeService: TolgeeService) {}

    static translate(key: string, params?: HashMap, fallbackValue?: string): string {
        return TolgeeService.translate(key, params, fallbackValue);
    }

    getActiveLanguage(): string {
        return TolgeeService.translate ? TolgeeService['instance']?.getLanguage() : 'de';
    }
}
